import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import role from './modules/role'
import dict from './modules/dict'
import menu from './modules/menu'
import getters from './getters'
import group from './modules/group'
import bom from './modules/bom'
import folder from './modules/folder'
import baseInfo from './modules/baseInfo'
import qualification from './modules/qualification'
import line from './modules/line'
import handover from './modules/handover'
import fault from './modules/fault'
import sop from './modules/sop'
import tech from './modules/tech'
import purchase from './modules/purchase'
import subject from './modules/subject'
import toolLabor from './modules/toolLabor'
import download from './modules/download'
import material from './modules/material'
import market from './modules/market'
import project from './modules/project'
import contract from './modules/contract'
import product from './modules/product'
import applicant from './modules/applicant'
import assessment from './modules/assessment'
import organizationalStructure from './modules/organizationalStructure'
import assetLedger from './modules/assetLedger'
import relevant from './modules/relevant'
import deviceType from './modules/deviceType'
import featureManagement from './modules/featureManagement'
import gasEquipmentLedger from './modules/gasEquipmentLedger'
import equipmentLedger from './modules/equipmentLedger'
import gasManagement from './modules/gasManagement'
import sparePartsManagement from './modules/sparePartsManagement'
import fileManagement from './modules/fileManagement'
import centralizedManagement from './modules/centralizedManagement'
import specialEquipmentLedger from './modules/specialEquipmentLedger'
import assetClassManagement from './modules/assetClassManagement'
import assetHeadManage from './modules/assetHeadManage'
import assetEcharts from './modules/assetEcharts'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    market,
    app,
    user,
    permission,
    role,
    dict,
    menu,
    group,
    bom,
    folder,
    baseInfo,
    qualification,
    line,
    handover,
    fault,
    sop,
    tech,
    purchase,
    subject,
    toolLabor,
    download,
    material,
    project,
    contract,
    product,
    applicant,
    assessment,
    organizationalStructure,
    assetLedger,
    relevant,
    deviceType,
    featureManagement,
    gasEquipmentLedger,
    equipmentLedger,
    gasManagement,
    sparePartsManagement,
    fileManagement,
    centralizedManagement,
    specialEquipmentLedger,
    assetClassManagement,
    assetHeadManage,
    assetEcharts
  },
  state: {

  },
  mutations: {

  },
  actions: {

  },
  getters
})
